module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0617.f12d0403.jpg";